// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5500/api';

// Authentication Endpoints
export const AUTH_ENDPOINTS = {
  // Traditional Authentication
  TRADITIONAL: {
    LOGIN: '/user/login',
    REGISTER: '/user/register',
    REFRESH: '/user/refresh-token',
    LOGOUT: '/user/logout',
  },
  
  // Cognito API Authentication
  COGNITO: {
    LOGIN: '/auth/cognito/login',
    REGISTER: '/auth/cognito/register',
    REFRESH: '/auth/cognito/refresh',
    LOGOUT: '/auth/cognito/logout',
    STATUS: '/auth/cognito/status',
    LINK_ACCOUNT: '/auth/cognito/link-account',
  },
  
  // OAuth/OIDC Authentication
  OAUTH: {
    LOGIN: '/auth/oauth/login',
    CALLBACK: '/auth/oauth/callback',
    VERIFY: '/auth/oauth/verify',  // New endpoint for code verification
    LOGOUT: '/auth/oauth/logout',
    STATUS: '/auth/oauth/status',
    USER_INFO: '/auth/oauth/user-info',
  }
};

// Authentication Methods
export const AUTH_METHODS = {
  TRADITIONAL: 'traditional',
  COGNITO: 'cognito',
  OAUTH: 'oauth'
};

// Storage Keys
export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  AUTH_METHOD: 'auth_method',
  USER_DATA: 'user_data'
};

// AWS Cognito Configuration
export const COGNITO_CONFIG = {
  REGION: process.env.REACT_APP_COGNITO_REGION || 'us-east-1',
  USER_POOL_ID: process.env.REACT_APP_COGNITO_USER_POOL_ID || 'us-east-1_Khp4RWjlL',
  CLIENT_ID: process.env.REACT_APP_COGNITO_CLIENT_ID || '3n1q6rddpobdtdaotiv80jo86c',
  DOMAIN: process.env.REACT_APP_COGNITO_DOMAIN || 'https://us-east-1khp4rwjll.auth.us-east-1.amazoncognito.com'
};